import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Apiurl from "../../environment/Apiurl";

function AddStaff() {
  const [responseDataDepartment, setResponseDataDepartment] = useState([]);
  const [shiftData, setShiftData] = useState([]);
  const [uniqueDepartments, setUniqueDepartments] = useState([]);
  const [filteredDesignations, setFilteredDesignations] = useState([]);

  const fetchDataDepartment = async () => {
    try {
      const response = await axios.get(`${Apiurl}/department`);
      const departments = response.data || [];
      setResponseDataDepartment(departments);

      // Extract unique departments
      const uniqueDepts = [
        ...new Set(departments.map((item) => item.department)),
      ];
      setUniqueDepartments(uniqueDepts);

      // Set initial designations based on first department or empty
      if (departments.length > 0) {
        const initialDesignations = departments
          .filter((item) => item.department === uniqueDepts[0])
          .map((item) => item.designation);
        setFilteredDesignations(initialDesignations);
      }
    } catch (error) {
      console.error("error", error.message);
    }
  };

  useEffect(() => {
    fetchDataDepartment();
  }, []);

  useEffect(() => {
    axios.get(`${Apiurl}/shift`).then((response) => setShiftData(response.data || [])).catch((error) => console.error("Error fetching shifts:", error.message));
  }, []);

      useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
  // generate staff id
  const [generateStaffID, setGenerateStaffId] = useState([]);

  const fetchGenerateData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/generate_staffno`);
      console.log("Response from server generate:", response.data.staff_id);
      setGenerateStaffId(response.data.staff_id);
      setAddData((prev) => ({ ...prev, staff_id: response.data.staff_id }));
      console.log("schudule", response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchGenerateData();
  }, []);

  const [addData, setAddData] = useState({
    staff_id: "",
    first_name: "",
    last_name: "",
    gender: "",
    dateofbirth: "",
    age: "",
    designation_name: "",
    department: "",
    qualification: "",
    salary: "",
    experience_years: "",
    mobile_no: "",
    alternate_mobile_no: "",
    email: "",
    aadhaar_no: "",
    pan_no: "",
    address: "",
    present_address: "",
    city: "",
    state: "",
    pincode: "",
    joining_date: "",
    employment_type: "",
    shift_timing: "",
    shift_id: "",
    bank_name: "",
    bank_account_no: "",
    ifsc_code: "",
    blood_group: "",
    profile_image_url: "",
    status: "",
    device_user_id: "",
    created_by: "",
    created_date: "",
  });

  const [errors, setErrors] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();

  const validateStep1 = () => {
    const newErrors = {};
    if (!addData.staff_id.trim()) newErrors.staff_id = "Staff ID is required";
    if (!addData.first_name.trim())
      newErrors.first_name = "First Name is required";
    if (!addData.last_name.trim())
      newErrors.last_name = "Last Name is required";
    if (!addData.gender) newErrors.gender = "Gender is required";
    if (!addData.dateofbirth)
      newErrors.dateofbirth = "Date of Birth is required";
    if (!addData.age || isNaN(addData.age) || addData.age <= 0)
      newErrors.age = "Valid age is required";
    if (!addData.designation_name)
      newErrors.designation_name = "Designation is required";
    if (!addData.department.trim())
      newErrors.department = "Department is required";
    if (!addData.qualification.trim())
      newErrors.qualification = "Qualification is required";
    if (!addData.salary.trim()) newErrors.salary = "Salary is required";
    if (
      !addData.experience_years ||
      isNaN(addData.experience_years) ||
      addData.experience_years < 0
    )
      newErrors.experience_years = "Valid experience years is required";
    if (!addData.mobile_no.match(/^\d{10}$/))
      newErrors.mobile_no = "Valid 10-digit mobile number is required";
    if (!addData.aadhaar_no.match(/^\d{12}$/))
      newErrors.aadhaar_no = "Valid 12-digit Aadhaar number is required";
    if (!addData.pan_no.match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/))
      newErrors.pan_no = "Valid PAN number is required";
    if (!addData.address.trim()) newErrors.address = "Address is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    const newErrors = {};

    if (!addData.city.trim()) newErrors.city = "City is required";
    if (!addData.state.trim()) newErrors.state = "State is required";
    if (!addData.pincode.match(/^\d{6}$/))
      newErrors.pincode = "Valid 6-digit PIN code is required";
    if (!addData.joining_date)
      newErrors.joining_date = "Joining Date is required";
    if (!addData.employment_type)
      newErrors.employment_type = "Employment Type is required";
    if (!addData.shift_id)
      newErrors.shift_id = "Shift is required";
    if (!addData.bank_name.trim())
      newErrors.bank_name = "Bank Name is required";
    if (!addData.bank_account_no.match(/^\d{9,18}$/))
      newErrors.bank_account_no = "Valid bank account number is required";
    if (!addData.ifsc_code.match(/^[A-Z]{4}0[A-Z0-9]{6}$/))
      newErrors.ifsc_code = "Valid IFSC code is required";
    if (!addData.blood_group.match(/^(A|B|AB|O)[+-]$/))
      newErrors.blood_group = "Valid blood group (e.g., A+, B-) is required";
    if (!addData.status) newErrors.status = "Status is required";
    if (!addData.device_user_id)
      newErrors.device_user_id = "Device User Id is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCancel = () => {
    navigate("/hr-management/staff");
  };

  const handleNext = async () => {
    if (activeStep === 0 && validateStep1()) {
      setActiveStep((prev) => prev + 1);
    } else if (activeStep === 1 && validateStep2()) {
      try {
        const formData = {
          staff_id: addData.staff_id,
          first_name: addData.first_name,
          last_name: addData.last_name,
          gender: addData.gender,
          dateofbirth: addData.dateofbirth,
          age: addData.age,
          designation_name: addData.designation_name,
          department: addData.department,
          qualification: addData.qualification,
          salary: addData.salary,
          experience_years: addData.experience_years,
          mobile_no: addData.mobile_no,
          alternate_mobile_no: addData.alternate_mobile_no,
          email: addData.email,
          aadhaar_no: addData.aadhaar_no,
          pan_no: addData.pan_no,
          address: addData.address,
          present_address: addData.present_address,
          city: addData.city,
          state: addData.state,
          pincode: addData.pincode,
          joining_date: addData.joining_date,
          employment_type: addData.employment_type,
          shift_timing: shiftData.find((s) => String(s._id) === String(addData.shift_id))?.shift_name || "",
          shift_id: addData.shift_id,
          bank_name: addData.bank_name,
          bank_account_no: addData.bank_account_no,
          ifsc_code: addData.ifsc_code,
          blood_group: addData.blood_group,
          profile_image_url: addData.profile_image_url,
          status: addData.status,
          device_user_id: addData.device_user_id,
          created_by: "",
          created_date: "",
        };
        console.log("formData", formData);
        const response = await axios.post(`${Apiurl}/staff`, formData);
        setAddData(response.data || "");
        navigate("/hr-management/staff");
      } catch (error) {
        console.log("error", error.message);
      }
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
    setErrors({});
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && !["image/jpeg", "image/png"].includes(file.type)) {
      setErrors({
        ...errors,
        profile_image_url: "Only JPEG or PNG images are allowed",
      });
      return;
    }
    setAddData({ ...addData, profile_image_url: file ? file.name : "" });
    setErrors({ ...errors, profile_image_url: "" });
  };

  // Handle department change and filter designations
  const handleDepartmentChange = (e) => {
    const selectedDept = e.target.value;
    setAddData({ ...addData, department: selectedDept, designation_name: "" });
    const designations = responseDataDepartment
      .filter((item) => item.department === selectedDept)
      .map((item) => item.designation);
    setFilteredDesignations(designations);
  };

  return (
    <>
      <div className="p-2">
        <div className="card card-body">
          {activeStep === 0 && (
            <>
              <div className="row">
                <div className="text-center mb-4">
                  <h5 className="">Step 1</h5>
                </div>
                {generateStaffID && (
                  <div className="col-lg-4">
                    <label htmlFor="staff_id">Staff ID</label>
                    <input
                      type="text"
                      className="form-control"
                      id="staff_id"
                      value={addData.staff_id}
                      onChange={(e) =>
                        setAddData({ ...addData, staff_id: e.target.value })
                      }
                    />
                    {errors.staff_id && (
                      <span className="text-danger">{errors.staff_id}</span>
                    )}
                  </div>
                )}

                <div className="col-lg-4">
                  <label htmlFor="first_name">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="first_name"
                    value={addData.first_name}
                    onChange={(e) =>
                      setAddData({ ...addData, first_name: e.target.value })
                    }
                  />
                  {errors.first_name && (
                    <span className="text-danger">{errors.first_name}</span>
                  )}
                </div>
                <div className="col-lg-4">
                  <label htmlFor="last_name">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="last_name"
                    value={addData.last_name}
                    onChange={(e) =>
                      setAddData({ ...addData, last_name: e.target.value })
                    }
                  />
                  {errors.last_name && (
                    <span className="text-danger">{errors.last_name}</span>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4">
                  <label htmlFor="gender">Gender</label>
                  <select
                    className="form-control"
                    id="gender"
                    value={addData.gender}
                    onChange={(e) =>
                      setAddData({ ...addData, gender: e.target.value })
                    }
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Transgender">Transgender</option>
                  </select>
                  {errors.gender && (
                    <span className="text-danger">{errors.gender}</span>
                  )}
                </div>

                <div className="col-lg-4">
                  <label htmlFor="dateofbirth">Date of Birth</label>
                  <input
                    type="date"
                    className="form-control"
                    id="dateofbirth"
                    value={addData.dateofbirth}
                    onChange={(e) => {
                      const dob = e.target.value;
                      const birthDate = new Date(dob);
                      const today = new Date();
                      let age = today.getFullYear() - birthDate.getFullYear();
                      const monthDiff = today.getMonth() - birthDate.getMonth();
                      if (
                        monthDiff < 0 ||
                        (monthDiff === 0 &&
                          today.getDate() < birthDate.getDate())
                      ) {
                        age--;
                      }
                      setAddData({
                        ...addData,
                        dateofbirth: dob,
                        age: age.toString(),
                      });
                    }}
                  />
                  {errors.dateofbirth && (
                    <span className="text-danger">{errors.dateofbirth}</span>
                  )}
                </div>
                <div className="col-lg-4">
                  <label htmlFor="age">Age</label>
                  <input
                    type="text"
                    className="form-control"
                    readOnly
                    id="age"
                    value={addData.age}
                    onChange={(e) =>
                      setAddData({ ...addData, age: e.target.value })
                    }
                  />
                  {errors.age && (
                    <span className="text-danger">{errors.age}</span>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4">
                  <label htmlFor="department">Department</label>
                  <select
                    className="form-control"
                    id="department"
                    value={addData.department}
                    onChange={handleDepartmentChange}
                  >
                    <option value="">Select Department</option>
                    {uniqueDepartments.map((dept) => (
                      <option key={dept} value={dept}>
                        {dept}
                      </option>
                    ))}
                  </select>
                  {errors.department && (
                    <span className="text-danger">{errors.department}</span>
                  )}
                </div>

                <div className="col-lg-4">
                  <label htmlFor="designation_name">Designation</label>
                  <select
                    className="form-control"
                    id="designation_name"
                    value={addData.designation_name}
                    onChange={(e) =>
                      setAddData({
                        ...addData,
                        designation_name: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Designation</option>
                    {filteredDesignations.map((designation) => (
                      <option key={designation} value={designation}>
                        {designation}
                      </option>
                    ))}
                  </select>
                  {errors.designation_name && (
                    <span className="text-danger">
                      {errors.designation_name}
                    </span>
                  )}
                </div>

                <div className="col-lg-4">
                  <label htmlFor="qualification">Qualification</label>
                  <input
                    type="text"
                    className="form-control"
                    id="qualification"
                    value={addData.qualification}
                    onChange={(e) =>
                      setAddData({ ...addData, qualification: e.target.value })
                    }
                  />
                  {errors.qualification && (
                    <span className="text-danger">{errors.qualification}</span>
                  )}
                </div>
                <div className="col-lg-4">
                  <label htmlFor="salary">Salary</label>
                  <input
                    type="text"
                    className="form-control"
                    id="salary"
                    value={addData.salary}
                    onChange={(e) =>
                      setAddData({ ...addData, salary: e.target.value })
                    }
                  />
                  {errors.salary && (
                    <span className="text-danger">{errors.salary}</span>
                  )}
                </div>
                <div className="col-lg-4">
                  <label htmlFor="experience_years">Experience</label>
                  <input
                    type="text"
                    className="form-control"
                    id="experience_years"
                    value={addData.experience_years}
                    onChange={(e) =>
                      setAddData({
                        ...addData,
                        experience_years: e.target.value,
                      })
                    }
                  />
                  {errors.experience_years && (
                    <span className="text-danger">
                      {errors.experience_years}
                    </span>
                  )}
                </div>

                <div className="col-lg-4">
                  <label htmlFor="mobile_no">Mobile</label>
                  <input
                    type="tel"
                    className="form-control"
                    id="mobile_no"
                    value={addData.mobile_no}
                    onChange={(e) =>
                      setAddData({ ...addData, mobile_no: e.target.value })
                    }
                  />
                  {errors.mobile_no && (
                    <span className="text-danger">{errors.mobile_no}</span>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4">
                  <label htmlFor="alternate_mobile_no">Optional Mobile</label>
                  <input
                    type="tel"
                    className="form-control"
                    id="alternate_mobile_no"
                    value={addData.alternate_mobile_no}
                    onChange={(e) =>
                      setAddData({
                        ...addData,
                        alternate_mobile_no: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-lg-4">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={addData.email}
                    onChange={(e) =>
                      setAddData({ ...addData, email: e.target.value })
                    }
                  />
                </div>
                <div className="col-lg-4">
                  <label htmlFor="aadhaar_no">Aadhaar No</label>
                  <input
                    type="tel"
                    className="form-control"
                    id="aadhaar_no"
                    value={addData.aadhaar_no}
                    onChange={(e) =>
                      setAddData({ ...addData, aadhaar_no: e.target.value })
                    }
                  />
                  {errors.aadhaar_no && (
                    <span className="text-danger">{errors.aadhaar_no}</span>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4">
                  <label htmlFor="pan_no">Pan No</label>
                  <input
                    type="text"
                    className="form-control"
                    id="pan_no"
                    value={addData.pan_no}
                    onChange={(e) =>
                      setAddData({ ...addData, pan_no: e.target.value })
                    }
                  />
                  {errors.pan_no && (
                    <span className="text-danger">{errors.pan_no}</span>
                  )}
                </div>

                <div className="col-lg-4">
                  <label htmlFor="address">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    id="address"
                    value={addData.address}
                    onChange={(e) =>
                      setAddData({ ...addData, address: e.target.value })
                    }
                  />
                  {errors.address && (
                    <span className="text-danger">{errors.address}</span>
                  )}
                </div>
                <div className="col-lg-4">
                  <label htmlFor="present_address">Present Address</label>
                  <input
                    type="text"
                    className="form-control"
                    id="present_address"
                    value={addData.present_address}
                    onChange={(e) =>
                      setAddData({
                        ...addData,
                        present_address: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <div className="d-flex justify-content-between">
                <button
                  className="btn btn-success btn-sm"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button className="btn btn-danger btn-sm" onClick={handleNext}>
                  Next
                </button>
              </div>
            </>
          )}

          {activeStep === 1 && (
            <>
              <div className="row">
                <div className="text-center mb-4">
                  <h5 className="">Step 2</h5>
                </div>

                <div className="col-lg-4">
                  <label htmlFor="city">City</label>
                  <input
                    type="text"
                    className="form-control"
                    id="city"
                    value={addData.city}
                    onChange={(e) =>
                      setAddData({ ...addData, city: e.target.value })
                    }
                  />
                  {errors.city && (
                    <span className="text-danger">{errors.city}</span>
                  )}
                </div>

                <div className="col-lg-4">
                  <label htmlFor="state">State</label>
                  <select
                    className="form-control"
                    id="state"
                    value={addData.state}
                    onChange={(e) =>
                      setAddData({ ...addData, state: e.target.value })
                    }
                  >
                    <option value="">Select State</option>
                    <option value="Andhra Pradesh">Andhra Pradesh</option>
                    <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                    <option value="Assam">Assam</option>
                    <option value="Bihar">Bihar</option>
                    <option value="Chhattisgarh">Chhattisgarh</option>
                    <option value="Goa">Goa</option>
                    <option value="Gujarat">Gujarat</option>
                    <option value="Haryana">Haryana</option>
                    <option value="Himachal Pradesh">Himachal Pradesh</option>
                    <option value="Jharkhand">Jharkhand</option>
                    <option value="Karnataka">Karnataka</option>
                    <option value="Kerala">Kerala</option>
                    <option value="Madhya Pradesh">Madhya Pradesh</option>
                    <option value="Maharashtra">Maharashtra</option>
                    <option value="Manipur">Manipur</option>
                    <option value="Meghalaya">Meghalaya</option>
                    <option value="Mizoram">Mizoram</option>
                    <option value="Nagaland">Nagaland</option>
                    <option value="Odisha">Odisha</option>
                    <option value="Punjab">Punjab</option>
                    <option value="Rajasthan">Rajasthan</option>
                    <option value="Sikkim">Sikkim</option>
                    <option value="Tamil Nadu">Tamil Nadu</option>
                    <option value="Telangana">Telangana</option>
                    <option value="Tripura">Tripura</option>
                    <option value="Uttar Pradesh">Uttar Pradesh</option>
                    <option value="Uttarakhand">Uttarakhand</option>
                    <option value="West Bengal">West Bengal</option>
                    <option value="Andaman and Nicobar Islands">
                      Andaman and Nicobar Islands
                    </option>
                    <option value="Chandigarh">Chandigarh</option>
                    <option value="Dadra and Nagar Haveli and Daman and Diu">
                      Dadra and Nagar Haveli and Daman and Diu
                    </option>
                    <option value="Delhi">Delhi</option>
                    <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                    <option value="Ladakh">Ladakh</option>
                    <option value="Lakshadweep">Lakshadweep</option>
                    <option value="Puducherry">Puducherry</option>
                  </select>

                  {errors.state && (
                    <span className="text-danger">{errors.state}</span>
                  )}
                </div>

                <div className="col-lg-4">
                  <label htmlFor="pincode">Pin Code</label>
                  <input
                    type="tel"
                    className="form-control"
                    id="pincode"
                    value={addData.pincode}
                    onChange={(e) =>
                      setAddData({ ...addData, pincode: e.target.value })
                    }
                  />
                  {errors.pincode && (
                    <span className="text-danger">{errors.pincode}</span>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4">
                  <label htmlFor="joining_date">Joining Date</label>
                  <input
                    type="date"
                    className="form-control"
                    id="joining_date"
                    value={addData.joining_date}
                    onChange={(e) =>
                      setAddData({ ...addData, joining_date: e.target.value })
                    }
                  />
                  {errors.joining_date && (
                    <span className="text-danger">{errors.joining_date}</span>
                  )}
                </div>

                <div className="col-lg-4">
                  <label htmlFor="employment_type">Employee Type</label>
                  <select
                    className="form-control"
                    id="employment_type"
                    value={addData.employment_type}
                    onChange={(e) =>
                      setAddData({
                        ...addData,
                        employment_type: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Employee</option>
                    <option value="Permanent">Permanent</option>
                    <option value="Contract">Contract</option>
                    <option value="Temporary">Temporary</option>
                  </select>
                  {errors.employment_type && (
                    <span className="text-danger">
                      {errors.employment_type}
                    </span>
                  )}
                </div>
                <div className="col-lg-4">
                  <label htmlFor="shift_id">Shift</label>
                  <select className="form-control" id="shift_id" value={addData.shift_id} onChange={(e) => { const sh = shiftData.find((item) => String(item._id) === String(e.target.value)); setAddData({ ...addData, shift_id: e.target.value, shift_timing: sh?.shift_name || "" }); }}>
                    <option value="">Select Shift</option>
                    {shiftData.filter((s) => s.status !== "Inactive").map((s) => <option key={s._id} value={s._id}>{s.shift_name} ({s.login_time} - {s.logout_time})</option>)}
                  </select>
                  {errors.shift_id && <span className="text-danger">{errors.shift_id}</span>}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <label htmlFor="bank_name">Bank Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="bank_name"
                    value={addData.bank_name}
                    onChange={(e) =>
                      setAddData({ ...addData, bank_name: e.target.value })
                    }
                  />
                  {errors.bank_name && (
                    <span className="text-danger">{errors.bank_name}</span>
                  )}
                </div>
                <div className="col-lg-4">
                  <label htmlFor="bank_account_no">Bank Account No</label>
                  <input
                    type="tel"
                    className="form-control"
                    id="bank_account_no"
                    value={addData.bank_account_no}
                    onChange={(e) =>
                      setAddData({
                        ...addData,
                        bank_account_no: e.target.value,
                      })
                    }
                  />
                  {errors.bank_account_no && (
                    <span className="text-danger">
                      {errors.bank_account_no}
                    </span>
                  )}
                </div>
                <div className="col-lg-4">
                  <label htmlFor="ifsc_code">IFSC Code</label>
                  <input
                    type="text"
                    className="form-control"
                    id="ifsc_code"
                    value={addData.ifsc_code}
                    onChange={(e) =>
                      setAddData({ ...addData, ifsc_code: e.target.value })
                    }
                  />
                  {errors.ifsc_code && (
                    <span className="text-danger">{errors.ifsc_code}</span>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-lg-4">
                  <label htmlFor="blood_group">Blood Group</label>
                  <input
                    type="text"
                    className="form-control"
                    id="blood_group"
                    value={addData.blood_group}
                    onChange={(e) =>
                      setAddData({ ...addData, blood_group: e.target.value })
                    }
                  />
                  {errors.blood_group && (
                    <span className="text-danger">{errors.blood_group}</span>
                  )}
                </div>
                <div className="col-lg-4">
                  <label htmlFor="profile_image_url">Profile Image</label>
                  <input
                    type="file"
                    className="form-control"
                    id="profile_image_url"
                    accept="image/jpeg,image/png"
                    onChange={handleFileChange}
                  />
                  {errors.profile_image_url && (
                    <span className="text-danger">
                      {errors.profile_image_url}
                    </span>
                  )}
                </div>
                <div className="col-lg-4">
                  <label htmlFor="status">Status</label>
                  <select
                    className="form-control"
                    id="status"
                    value={addData.status}
                    onChange={(e) =>
                      setAddData({ ...addData, status: e.target.value })
                    }
                  >
                    <option value="">Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Resigned">Resigned</option>
                  </select>
                  {errors.status && (
                    <span className="text-danger">{errors.status}</span>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <label htmlFor="device_user_id">ZKTeco Device User ID</label>
                  <input
                    type="text"
                    className="form-control"
                    id="device_user_id"
                    value={addData.device_user_id}
                    onChange={(e) =>
                      setAddData({ ...addData, device_user_id: e.target.value })
                    }
                  />
                  {errors.device_user_id && (
                    <span className="text-danger">{errors.device_user_id}</span>
                  )}
                </div>
              </div>

              <div className="d-flex justify-content-between">
                <button className="btn btn-success btn-sm" onClick={handleBack}>
                  Back
                </button>
                <button className="btn btn-danger btn-sm" onClick={handleNext}>
                  Submit
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default AddStaff;
